// Hebt Potrees GLSL-ES-1.00-Shader auf ES 3.00 (WebGL 2). Dieselbe Technik wie three.js für
// ShaderMaterial: Version + #defines voranstellen, die Quellen selbst bleiben unverändert.
// Nötig, weil gl_FragDepthEXT / EXT_frag_depth unter WebGL 2 nicht existieren und three seit r163
// nur noch WebGL 2 bedient. RawShaderMaterial und Potrees eigene Shader-Klasse bekommen von three
// keinen solchen Kopf, deshalb hier zentral.

const MARKER = '// potree-glsl3';

const VS_HEADER = [
	MARKER,
	'#define attribute in',
	'#define varying out',
	'#define texture2D texture',
	'#define textureCube texture',
	'',
].join('\n');

const FS_HEADER = [
	MARKER,
	'#define varying in',
	'out highp vec4 pc_fragColor;',
	'#define gl_FragColor pc_fragColor',
	'#define gl_FragDepthEXT gl_FragDepth',
	'#define texture2D texture',
	'#define textureCube texture',
	'',
].join('\n');

/**
 * @param {string} source   Shader-Quelle (ES 1.00, ggf. mit vorangestellten #defines)
 * @param {'vs'|'fs'} stage
 * @param {boolean} withVersion  true: "#version 300 es" selbst voranstellen (eigene Kompilierung);
 *                               false: three stellt die Version voran (RawShaderMaterial mit glslVersion GLSL3)
 */
export function toGLSL3(source, stage, withVersion) {
	let body = source
		.replace(/^[ \t]*#version[^\n]*\n?/m, '')                 // Version kommt von uns bzw. three
		.replace(/^[ \t]*#extension\s+GL_EXT_frag_depth[^\n]*\n?/mg, '');   // in ES 3.00 Kernfunktion

	// idempotent: Quellen, die den Kopf schon tragen (z.B. PointCloudMaterial, das sowohl
	// three als auch Potrees eigene Shader-Klasse durchläuft), nicht ein zweites Mal versehen
	let header = body.includes(MARKER) ? '' : (stage === 'vs' ? VS_HEADER : FS_HEADER);

	return (withVersion ? '#version 300 es\n' : '') + header + body;
}
